import React from "react";
import styles from "./Button.module.scss";
import classNames from "classnames";
import AnimationLoader from "../AnimationLoader/AnimationLoader";

export interface ButtonProps {
  id?: string;
  cssClassName?: string;
  disabled?: boolean;
  loader?: boolean;
  height?: "40" | "48";
  type: "button" | "submit";
  name: string;
  onClick?: React.MouseEventHandler<any>;
  typeStyle?: "primary" | "ghost" | "secondary";
  notFullWidth?: boolean;
}

class Button extends React.Component<ButtonProps> {

  render() {

    let width;
    if (this.props.notFullWidth === true) {
      width = "ButtonNotFullWidth";
    } else {
      width = "ButtonFullWidth";
    }
    let height = "ButtonHeight40";
    if (this.props.height === "48") {
      height = "ButtonHeight48";
    }

    let buttonTypeStyle = "ButtonPrimary";
    if (this.props.typeStyle === "ghost") {
      buttonTypeStyle = "ButtonGhost";
    } else if (this.props.typeStyle === "secondary") {
      buttonTypeStyle = "ButtonSecondary";
    }

    let loaderStyles = "";
    if (this.props.loader) {
      loaderStyles = styles.ButtonPrimaryLoader;
    }

    return (
      <button
        id={this.props.id}
        name={this.props.name}
        type={this.props.type}
        className={classNames(
          styles.Button,
          this.props.cssClassName,
          loaderStyles,
          styles[buttonTypeStyle],
          styles[width],
          styles[height]
        )}
        disabled={this.props.disabled}
        onClick={this.props.onClick}>

        {!this.props.loader &&
        this.props.children
        }

        {this.props.loader &&
        <AnimationLoader height={this.props.height}/>
        }

      </button>
    );
  }
}

export default Button;
